/// <reference types="vite/client" />
import {normalizeNotifyServiceUrl} from './notify-url'

// we are using this ternary ugly thing with `import.meta.env?` and `process.env` because this variables will be loaded in different runtimes, and not in all runtines both "ways" are available.

const IME: Record<string, any> = (() => {
  try {
    // Check if we're in a Vite environment by looking for import.meta
    if (typeof globalThis !== 'undefined' && 'importMeta' in globalThis) {
      return (globalThis as any).importMeta?.env ?? {}
    }
    // Try direct access in modern environments
    // @ts-ignore
    if (typeof import.meta !== 'undefined' && import.meta.env) {
      // @ts-ignore
      return import.meta.env
    }
    return {}
  } catch {
    return {}
  }
})()

const WEB_ENV = (() => {
  try {
    return (window as any).ENV || {}
  } catch (e) {
    return {}
  }
})()

export const DEFAULT_GATEWAY_URL: string = IME.VITE_GATEWAY_URL || process.env.VITE_GATEWAY_URL || 'https://hyper.media'

export const DEFAULT_DESKTOP_VAULT_URL: string | undefined =
  IME.VITE_DESKTOP_DEFAULT_VAULT_URL || process.env.VITE_DESKTOP_DEFAULT_VAULT_URL || undefined

// The dev shell redefines the agents server port (.env.vars); the fallback matches the
// production default baked into agents/src/config.ts.
export const DEFAULT_DESKTOP_AGENTS_URL: string =
  IME.VITE_DESKTOP_DEFAULT_AGENTS_URL || process.env.VITE_DESKTOP_DEFAULT_AGENTS_URL || 'http://localhost:3050'

export const P2P_PORT = IME.VITE_DESKTOP_P2P_PORT || process.env.VITE_DESKTOP_P2P_PORT || 56000

export const DAEMON_HTTP_PORT =
  process.env.DAEMON_HTTP_PORT || IME.VITE_DESKTOP_HTTP_PORT || process.env.VITE_DESKTOP_HTTP_PORT || 56001
export const DAEMON_GRPC_PORT = IME.VITE_DESKTOP_GRPC_PORT || process.env.VITE_DESKTOP_GRPC_PORT || 56002

export const METRIC_SERVER_HTTP_PORT =
  IME.VITE_METRIC_SERVER_HTTP_PORT || process.env.VITE_METRIC_SERVER_HTTP_PORT || 56003

export const API_HTTP_PORT = IME.VITE_DESKTOP_API_PORT || process.env.VITE_DESKTOP_API_PORT || 56004

export const DAEMON_HOSTNAME = IME.VITE_DESKTOP_HOSTNAME || process.env.VITE_DESKTOP_HOSTNAME

export const DESKTOP_APPDATA = IME.VITE_DESKTOP_APPDATA || process.env.VITE_DESKTOP_APPDATA || 'Seed'

export const VERSION = IME.VITE_VERSION || process.env.VITE_VERSION || '0.0.100-dev'

export const COMMIT_HASH =
  IME.VITE_COMMIT_HASH ||
  process.env.VITE_COMMIT_HASH ||
  'LOCAL_abcdefghijklmnopqrst0123456789qwertyuiopasdfghjklzxcvbnm'

// this is injected by Vite, so it indicates if we are in the production build of the DESKTOP app

export const IS_PROD_DESKTOP = !!IME.PROD || process.env.NODE_ENV === 'production'

// Always use 'hm' for document URLs (backend only supports this)
export const HYPERMEDIA_SCHEME = 'hm'

export const OS_PROTOCOL_SCHEME = 'hm'

export const IS_DESKTOP = (() => {
  try {
    return typeof window !== 'undefined' && 'ipc' in window
  } catch {
    return false
  }
})()

export const IS_WEB = !IS_DESKTOP

export const AVOID_UPDATES = !!IME.VITE_AVOID_UPDATES || process.env.VITE_AVOID_UPDATES == 'true' || false

export const IS_PROD_DEV = IS_PROD_DESKTOP && VERSION?.includes('-dev')
export const IS_TEST = process.env.NODE_ENV == 'test'

export const DAEMON_HTTP_URL =
  IME.DAEMON_HTTP_URL || process.env.DAEMON_HTTP_URL || `${DAEMON_HOSTNAME || 'http://127.0.0.1'}:${DAEMON_HTTP_PORT}`

export const API_HTTP_URL = `${DAEMON_HOSTNAME || 'http://localhost'}:${API_HTTP_PORT}`

export const DAEMON_FILE_UPLOAD_URL = `${DAEMON_HTTP_URL}/ipfs/file-upload`

export const MAX_FILE_SIZE_MB = 150
export const MAX_FILE_SIZE_B = MAX_FILE_SIZE_MB * 1024 * 1024

export const DAEMON_GRAPHQL_ENDPOINT = `${DAEMON_HOSTNAME}:${DAEMON_HTTP_PORT}/graphql`

export const SITE_BASE_URL = WEB_ENV.SITE_BASE_URL || process.env.SEED_BASE_URL || 'https://hyper.media'

export const LIGHTNING_API_URL =
  WEB_ENV.LIGHTNING_API_URL ||
  process.env.LIGHTNING_API_URL ||
  IME.VITE_LIGHTNING_API_URL ||
  'https://ln.seed.hyper.media'

export const VITE_DESKTOP_SENTRY_DSN = IME.VITE_DESKTOP_SENTRY_DSN || process.env.VITE_DESKTOP_SENTRY_DSN

export const BIG_INT = 2 ** 25 // 2^31 was too big for grpc

/** Hosting service origin; web deployments inject their runtime setting before client bundles load. */
export const SEED_HOST_URL =
  WEB_ENV.SEED_HOST_URL ||
  process.env.SEED_HOST_URL ||
  process.env.VITE_SEED_HOST_URL ||
  IME.VITE_SEED_HOST_URL ||
  'http://localhost:5555'

export const SEED_ASSET_HOST = WEB_ENV.SEED_ASSET_HOST || process.env.SEED_ASSET_HOST || IME.SEED_ASSET_HOST

export const DAEMON_FILE_URL = `${SEED_ASSET_HOST || DAEMON_HTTP_URL}/ipfs`

export const WEB_IDENTITY_ORIGIN =
  WEB_ENV.WEB_IDENTITY_ORIGIN ||
  process.env.WEB_IDENTITY_ORIGIN ||
  process.env.SEED_IDENTITY_DEFAULT_ORIGIN ||
  'https://hyper.media'

// when web identity is enabled, we will REDIRECT to web identity origin to sign comments
// this will be enabled on all origins
export const WEB_IDENTITY_ENABLED = WEB_ENV.WEB_IDENTITY_ENABLED || process.env.SEED_IDENTITY_ENABLED !== 'false' // ENABLED BY DEFAULT

// this will be enabled when the web origin matches the SEED_BASE_URL, and passed to the client explicitly in props
export const WEB_SIGNING_ENABLED = true

export const NOTIFY_SMTP_HOST = process.env.NOTIFY_SMTP_HOST
export const NOTIFY_SMTP_PORT = process.env.NOTIFY_SMTP_PORT
export const NOTIFY_SMTP_USER = process.env.NOTIFY_SMTP_USER
export const NOTIFY_SMTP_PASSWORD = process.env.NOTIFY_SMTP_PASSWORD
export const NOTIFY_SENDER = process.env.NOTIFY_SENDER
// The hosting service's HTTPS email relay; when set, notify sends through it instead of SMTP.
export const NOTIFY_EMAIL_RELAY_URL = process.env.NOTIFY_EMAIL_RELAY_URL
export const NOTIFY_EMAIL_RELAY_TOKEN = process.env.NOTIFY_EMAIL_RELAY_TOKEN
export const NOTIFY_TRUSTED_PREVALIDATORS = process.env.NOTIFY_TRUSTED_PREVALIDATORS

export const WEB_IS_GATEWAY = WEB_ENV.WEB_IS_GATEWAY ?? process.env.SEED_IS_GATEWAY === 'true'

export const WEB_API_DISABLED = process.env.SEED_API_ENABLED === 'false'

export const ENABLE_EMAIL_NOTIFICATIONS =
  WEB_ENV.ENABLE_EMAIL_NOTIFICATIONS ||
  !!(NOTIFY_EMAIL_RELAY_URL && NOTIFY_EMAIL_RELAY_TOKEN) ||
  !!(NOTIFY_SMTP_HOST && NOTIFY_SMTP_PORT && NOTIFY_SMTP_USER && NOTIFY_SMTP_PASSWORD && NOTIFY_SENDER)

/**
 * Base URL of the notify service: canonical (`https://site.com/hm/api/notify`) or a legacy
 * origin-only value. Retired hosted hostnames are rewritten; build URLs with `notifyEndpointUrl`.
 */
export const NOTIFY_SERVICE_HOST: string | undefined =
  normalizeNotifyServiceUrl(
    process.env.NOTIFY_SERVICE_HOST || // web server (runtime env must beat the build-time VITE value,
      // which vite bakes into the SSR bundle from .env.vars on dev machines)
      IME.VITE_NOTIFY_SERVICE_HOST || // desktop app
      WEB_ENV.NOTIFY_SERVICE_HOST, // web client
  ) ?? undefined

/**
 * Default agent server for the web app's /hm/agents UI. The site will eventually support several
 * configured agent servers (as desktop does); for now this is the seed of the configured list.
 *
 * The dev fallback matches the harness dev agents server port (see agents/.env.vars), not the
 * packaged binary's 3050 — a stale packaged server on 3050 answers but 400s the runs API.
 */
/**
 * Agents setting that decides whether the desktop app runs its bundled local agents server.
 * `'on'` or `'off'`; unset means a build that always ran it has not decided yet.
 */
export const AGENTS_LOCAL_SERVER_SETTING_KEY = 'agentsLocalServer'

export const SEED_AGENT_SERVER_URL: string | undefined = (() => {
  // An explicitly empty value means "no agent server" (single-tenant sites set
  // it), so only an unset variable falls back to the shared default.
  const configured =
    process.env.SEED_AGENT_SERVER_URL ?? // web server
    WEB_ENV.SEED_AGENT_SERVER_URL // web client
  if (typeof configured === 'string') return configured || undefined
  return process.env.NODE_ENV === 'production' ? 'https://agentic.seed.hyper.media' : 'http://localhost:3051'
})()

// Discovery timeouts
export const DISCOVERY_TIMEOUT_MS = 15_000 // 15 seconds before showing not-found
export const DISCOVERY_DEBOUNCE_MS = 100 // debounce rapid mounts

export const ENABLE_WEB_INSTRUMENTATION = process.env.SEED_INSTRUMENTATION === 'dev'
